import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=670b6bbb&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b6bbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670b6bbb')) {
      api.createRecord('670b6bbb', component.options)
    } else {
      api.reload('670b6bbb', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=670b6bbb&scoped=true&", function () {
      api.rerender('670b6bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t2QgXHCxwQQP/JS/comp/SearchFilterTokens.vue"
export default component.exports